import { createRouter, createWebHistory } from "vue-router";
import { nextTick } from "vue";
import config from "../config/index";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      title: "Home",
      description: "Welcome to Abington Heights Townhomes in Roy, Utah. Discover luxury townhomes with modern amenities, smart home features, and easy access to northern Utah's best attractions.",
    },
  },
  {
    path: "/availability",
    name: "Availability",
    component: () =>
      import(
        /* webpackChunkName: "availability" */ "../views/Availability.vue"
      ),
    meta: {
      title: "Availability",
      description: "Check current availability at Abington Heights Townhomes. View available units, floor plans, and join our waiting list for upcoming openings in Roy, Utah.",
    },
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import(/* webpackChunkName: "faq" */ "../views/FAQ.vue"),
    meta: {
      title: "Frequently Asked Questions",
      description: "Find answers to common questions about Abington Heights Townhomes, including leasing information, amenities, pet policies, and community features in Roy, Utah.",
    },
  },
  {
    path: "/apply-now",
    name: "Applications",
    component: () =>
      import(
        /* webpackChunkName: "applications" */ "../views/Landing_pages/Applications.vue"
      ),
    meta: {
      title: "Apply Now",
      description: "Apply for your new home at Abington Heights Townhomes. Start your application process online and take the first step toward luxury living in Roy, Utah.",
    },
  },
  {
    path: "/book-a-tour",
    name: "Showing",
    component: () =>
      import(
        /* webpackChunkName: "showing" */ "../views/Landing_pages/Showing.vue"
      ),
    meta: {
      title: "Book a Tour",
      description: "Schedule a tour of Abington Heights Townhomes. See our luxury townhomes, amenities, and experience the community firsthand in Roy, Utah.",
    },
  },
  {
    path: "/get-more-info",
    name: "Guest_cards",
    component: () =>
      import(
        /* webpackChunkName: "guest-cards" */ "../views/Landing_pages/Guest_cards.vue"
      ),
    meta: {
      title: "Get More Info",
      description: "Request more information about Abington Heights Townhomes. Learn about our floor plans, amenities, location, and leasing options in Roy, Utah.",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const nav = document.querySelector("#nav");
      return {
        el: to.hash,
        top: nav.scrollHeight,
        behavior: "smooth",
      };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
});

router.beforeEach((to) => {
  nextTick(() => {
    // Set page title using meta.title or fallback to route name
    const pageTitle = to.meta?.title || to.name;
    document.title = `${config.communityName} - ${pageTitle}`;

    // Handle meta description
    const metaDescription = to.meta?.description;
    if (metaDescription) {
      let metaDescTag = document.querySelector('meta[name="description"]');
      if (!metaDescTag) {
        metaDescTag = document.createElement('meta');
        metaDescTag.setAttribute('name', 'description');
        document.getElementsByTagName('head')[0].appendChild(metaDescTag);
      }
      metaDescTag.setAttribute('content', metaDescription);
    }
  });
});

export default router;
